import type { ScrollViewProps as BaseProps } from "react-native"

import React from "react"
import { ScrollView as Base, Platform, StyleSheet } from "react-native"
import { useStyle } from "react-native-style-utilities"

import { testIds, type TestId } from "./test-id"

import { HEADER_LARGE_SCROLL_CHILD_PROPS } from "@/theme/constants"
import { SIZES, SPACING, Theme } from "./theme"

export type ScrollViewProps = Omit<BaseProps, "id"> & {
  id?: TestId
  variant?: "form" | "screen" | "screenContainerHeaderLarge"
}

export const ScrollView = React.forwardRef<Base, ScrollViewProps>(
  function ScrollView(
    { contentContainerStyle, id, style, variant, ...rest },
    ref,
  ) {
    return (
      <Base
        ref={ref}
        {...testIds(id)}
        {...HEADER_LARGE_SCROLL_CHILD_PROPS}
        style={useStyle(() => [style], [style])}
        contentContainerStyle={useStyle(
          () => [
            variant === "screenContainerHeaderLarge" &&
              styles.screenContainerHeaderlarge,
            variant === "form" && styles.variantForm,
            variant === "screen" && styles.variantScreen,
            contentContainerStyle,
          ],
          [contentContainerStyle, variant],
        )}
        {...rest}
      />
    )
  },
)

const styles = StyleSheet.create({
  paper: {
    backgroundColor: Theme.COLORS.$paper.light,
  },
  paperDark: {
    backgroundColor: Theme.COLORS.$paper.dark,
  },
  screenContainerHeaderlarge: {
    padding: SPACING.$4,
    paddingBottom: SPACING.$toolbar,
    paddingTop: Platform.select({
      android: SPACING.$2,
      ios: SPACING.$toolbar,
    }),
  },
  variantForm: {
    marginHorizontal: "auto",
    maxWidth: SIZES.$2xl,
    paddingBottom: SPACING.$toolbar,
    paddingHorizontal: SPACING.$4,
    paddingTop: SPACING.$4,
    width: "100%",
  },
  variantScreen: {
    marginHorizontal: "auto",
    marginTop: SPACING.$2,
    maxWidth: SIZES.$5xl,
    paddingBottom: SPACING.$toolbar,
    paddingHorizontal: SPACING.$4,
    width: "100%",
  },
  webAppPageContentContainer: {
    flexGrow: 0,
  },
  webAppPageRoot: {
    flexGrow: 0,
  },
})
